
import "./main.css"
import "./blocks.css"

import Home from "./components/Home";

function App() {

    console.log("Main Page!")

    return (
        <div className="App">
            <Home />
        </div>
    );
}

export default App;
